"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getModifierStatus = void 0;
var isMatch_1 = require("./isMatch");
/**
 * Return the status of the modifiers that matches the given date.
 */
function getModifierStatus(date, 
/** The modifiers to match for the given date. */
modifiers) {
    var modifiersList = Object.keys(modifiers).reduce(function (previousValue, key) {
        var modifier = modifiers[key];
        if (isMatch_1.isMatch(date, modifier)) {
            previousValue.push(key);
        }
        return previousValue;
    }, []);
    var modifiersStatus = {};
    modifiersList.forEach(function (modifier) { return (modifiersStatus[modifier] = true); });
    return modifiersStatus;
}
exports.getModifierStatus = getModifierStatus;
//# sourceMappingURL=getModifierStatus.js.map